import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'unset',
    padding: '6px 14px',
    width: '100%'
  }
}));

const ExportButton = ({ option, handleClick, Component, componentProps }) => {
  const classes = useStyles();

  const button = useMemo(
    () => (
      <Box
        onClick={handleClick}
        component="button"
        value={option.value}
        bgcolor="#F9F9F9"
        className={classes.iconWrapper}
        color={option.color}
      >
        {option.icon}
        <Typography variant="subtitle1" color="textPrimary">
          {option.value.toUpperCase()}
        </Typography>
      </Box>
    ),
    [handleClick, option.value, option.color, option.icon, classes.iconWrapper]
  );

  return Component ? (
    <Grid item xs={5} key={option.color}>
      <Component {...componentProps}>{button}</Component>
    </Grid>
  ) : (
    <Grid item xs={5} key={option.color}>
      {button}
    </Grid>
  );
};

ExportButton.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
  Component: PropTypes.node,
  componentProps: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string
    })
  })
};

ExportButton.defaultProps = {
  Component: null,
  componentProps: null
};

export default ExportButton;
